import { jwtDecode } from "jwt-decode";

// Function to get the token (customize to check both jwtToken and authToken)
const getToken = () => {
    const jwtToken = localStorage.getItem("jwtToken");
    const authToken = localStorage.getItem("authToken");
    return jwtToken || authToken; // Return the first available token
};

// Function to decode the token and check if it's expired
const isTokenExpired = (token) => {
    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Current time in seconds
        return decoded.exp < currentTime;
    } catch (error) {
        console.error("Error decoding token:", error);
        return true; // Assume expired if decoding fails
    }
};

// Function to calculate time until expiration (in milliseconds)
const getTimeUntilExpiration = (token) => {
    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Current time in seconds
        const timeLeft = (decoded.exp - currentTime) * 1000; // Convert to milliseconds
        return timeLeft > 0 ? timeLeft : 0;
    } catch (error) {
        console.error("Error calculating expiration:", error);
        return 0;
    }
};

// Function to log out the user (customizable)
const defaultLogout = (dispatch) => {
    dispatch({ type: "LOGOUT" }); // Dispatch logout action to update state
};

// Main auto-logout function
const setupAutoLogout = (options = {}) => {
    const {
        getTokenFn = getToken, // Allow custom token retrieval
        logoutFn = defaultLogout, // Allow custom logout behavior
        dispatch, // Required to dispatch logout action
        onWarning, // Optional callback for warning before logout
        warningTime = 60000, // Default to 1 minute warning (in milliseconds)
    } = options;

    const token = getTokenFn();
    if (!token || !dispatch) return;

    if (isTokenExpired(token)) {
        logoutFn(dispatch);
    } else {
        const timeUntilExpiration = getTimeUntilExpiration(token);

        if (onWarning && timeUntilExpiration > warningTime) {
            // Set a timeout for the warning
            setTimeout(() => {
                onWarning({
                    logout: () => logoutFn(dispatch),
                    timeUntilExpiration,
                });
            }, timeUntilExpiration - warningTime);
        } else {
            // No warning, just log out when it expires
            setTimeout(() => {
                console.log("Token expired, logging out...");
                logoutFn(dispatch);
            }, timeUntilExpiration);
        }
    }
};

export { isTokenExpired, setupAutoLogout }; // Export isTokenExpired for reuse
